<template>
  <dialog_CustomerEdit v-if="dialog_show" :editDialogSwitch="editDialogSwitch" :customer="customer" :reloadForSync="reloadAll" :gotEditingPart="activeMenu"/>
  <dialog_caEdit v-if="useEditDialog" :p_solution="selectedSolution" :closeFunction="editDialogOnOff" :reload="reloadPage" />

  <div id="dialog-customer-view" class="dialog">
    <span class="cls" @click="oth_viewCustomer(false)"></span>
    <div class="paper">
      <div class="header">
        <p>고객 > 고객리스트</p>
        <p @click="oth_viewCustomer(false)"><i class="ph-bold ph-x"></i></p>
      </div>
      <div class="content">
        <!-- Left Sidebar -->
        <div class="left">
          <div class="profile">
            <img :src="customer.image || '/imgs/unknow_user.png'" alt="Profile" />
            <button 
              class="bookmark" 
              :class="{ marked: bookmarkChecked }"
              @click="bookmarkToggle(customer)"
            >
              <i :class="bookmarkChecked ? 'ph-fill ph-star' : 'ph-bold ph-star'"></i>
            </button>
            <div class="profile-info">
              <div class="name-badges">
                <h2>{{ customer.name || '무명' }}</h2>
                <span class="badge badge-coach">{{customer.title}}</span>
                <span class="badge badge-offical" v-if="customer.is_offical">공식</span>
                <span class="badge badge-mtype" v-if="customer.m_type">{{customer.m_type}}</span>
                <span class="badge badge-managerank" v-if="customer.manage_rank">{{manageText(customer.manage_rank)}}</span>
                <span class="badge badge-vip" v-if="customer.vip_rank > 0">{{'V'.repeat(customer.vip_rank)}}IP</span>
                <span class="badge badge-keyman" v-if="customer.is_keyman">키맨</span>
              </div>
              <p class="nickname">{{ customer.nickname || '고객님' }}</p>
              <p class="phone">TEL. {{ formatKRPhone(customer.phone) || '041-124-1244' }}</p>
            </div>
          </div>
          
          <ul class="menus">
            <li :class="{ active: activeMenu === 'basic' }" @click="activeMenu = 'basic'">
              <span>🙎‍♀️ 기본정보</span>
            </li>
            <li :class="{ active: activeMenu === 'job' }" @click="activeMenu = 'job'">
              <span>💼 직업정보</span>
            </li>
            <li :class="{ active: activeMenu === 'family' }" @click="activeMenu = 'family'">
              <span>👨‍👩‍👧‍👦 가족정보</span>
            </li>
            <!-- <li :class="{ active: activeMenu === 'sales' }" @click="activeMenu = 'sales'">
              <span>📒 소개정보 (인원/소개자/가망자)</span>
            </li> -->
            <li :class="{ active: activeMenu === 'insurance' }" @click="activeMenu = 'insurance'">
              <span>📊 보장 스캐치(분석/제안)</span>
            </li>
            <!-- <li :class="{ active: activeMenu === 'life' }" @click="activeMenu = 'life'">
              <span>📞 상품 가입정보</span>
            </li> -->
            <li :class="{ active: activeMenu === 'employment' }" @click="activeMenu = 'employment'">
              <span>🩺 고지사항 (병력사항)</span>
            </li>
            <li :class="{ active: activeMenu === 'claims' }" @click="activeMenu = 'claims'">
              <span>💰 청구이력</span>
            </li>
            <li :class="{ active: activeMenu === 'consultation' }" @click="activeMenu = 'consultation'">
              <span>📆 접촉이력 (상담/미팅/선물/통화/문자)</span>
            </li>
            <li :class="{ active: activeMenu === 'event' }" @click="activeMenu = 'event'">
              <span>🎂 기념일/이벤트</span>
            </li>
            <li :class="{ active: activeMenu === 'materials' }" @click="activeMenu = 'materials'">
              <span>📁 자료보관</span>
            </li>
            <li :class="{ active: activeMenu === 'memo' }" @click="activeMenu = 'memo'">
              <span>💬 메모</span>
            </li>
            <li :class="{ active: activeMenu === 'map' }" @click="activeMenu = 'map'">
              <span>📍 위치 및 주변고객</span>
            </li>
          </ul>
        </div>
        
        <!-- Right Content -->
        <div class="right">
          
          <!-- 기본정보 Section -->
          <div class="information" v-if="activeMenu === 'basic'">
            <div class="info-header">
              <h2>🙎‍♀️ 기본정보</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
              <span @click="deleteCustomer()"> <i class="ph ph-trash"></i> </span>
            </div>
            
            <div class="info-summary">
              <div class="summary-double">
                <div class="summary-double-item">
                  <span class="label">성명:</span>
                  <span class="value">{{ customer.name || '홍길동' }}</span>
                </div>
                <div class="summary-double-item">
                  <span class="label">별칭:</span>
                  <span class="value">{{ customer.nickname || '-' }}</span>
                </div>
                <div class="summary-double-item">
                  <span class="label">문자호칭:</span>
                  <span class="value">{{ customer.title || '고객님' }}</span>
                </div>
              </div>
              <div class="summary-double">
                <div class="summary-double-item">
                  <span class="label">나이</span>
                  <span class="value">{{ calculateInsuAge ? calculateInsuAge(customer?.rrn?.split('-')[0]) + '세' : '-' }}</span>
                </div>
                <div class="summary-double-item">
                  <span class="label">성별</span>
                  <span class="value"> {{ genderChoser(customer?.rrn?.split('-')[1]?.slice(0, 1)) || '-' }} </span>
                </div>
                <div class="summary-double-item">
                  <span class="label">생년월일</span>
                  <span class="value">{{ customer?.rrn?.split('-')[0] || '-' }}</span>
                </div>
                <div class="summary-double-item">
                  <span class="label">고유번호</span>
                  <span class="value"> {{ maskRRN(customer.rrn) || '-' }} </span>
                </div>
              </div>
              <div class="summary-item">
                <span class="label">그룹:</span>
                <div class="tags">
                  <span class="tag" v-for="(tag, index) in customer.tags" :key="index">#{{ tag }}</span>
                </div>
              </div>
            </div> 

            <div class="detail-section">
              <h3>상세정보</h3>
              <div class="detail-grid">
                <div class="detail-row">
                  <span class="label">연락처</span>
                  <span class="value">{{ formatKRPhone(customer.phone) || '-' }}</span>
                </div>
                <div class="detail-row" v-if=customer.birth>
                  <span class="label">실제생일</span>
                  <span class="value">{{ customer.birth || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">주소</span>
                  <div class="address-wrapper">
                    <span class="value">{{ customer.address || '-' }}</span>
                    <button class="btn-map" @click="goToUrl(`https://map.naver.com/p/search/${customer.address}`)" v-if="customer.address">주변보기</button>
                  </div>
                </div>
                <div class="detail-row">
                  <span class="label">상세주소</span>
                  <span class="value">{{ customer.ex_address || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">시군구</span>
                  <span class="value">{{ customer.location || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">관계</span>
                  <span class="value">{{ customer.m_type || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">나와의 관계</span>
                  <span class="value">{{ customer.relation_to_me || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">관리등급</span>
                  <span class="value">{{ manageText(customer.manage_rank) || '-' }}</span>
                </div>
              </div>
            </div>

            <div class="detail-section">
              <h3>수신동의</h3>
              <div class="agreement-view-list">
                <!-- <div class="agreement-view-item">
                  <div class="checkbox" :class="{ checked: customer.agree_privacy == 1 }">
                    <i class="ph-bold ph-check" v-if="customer.agree_privacy == 1"></i>
                  </div>
                  <div class="agreement-info">
                    <span class="label">개인정보 수집 및 이용</span>
                    <span class="badge required">필수</span>
                  </div>
                  <span class="date">{{ customer.agree_privacy_at ? formatDate(customer.agree_privacy_at) : '-' }}</span>
                </div> -->

                <div class="agreement-view-item">
                  <div class="checkbox" :class="{ checked: customer.agree_sms == 1 }">
                    <i class="ph-bold ph-check" v-if="customer.agree_sms == 1"></i>
                  </div>
                  <div class="agreement-info">
                    <span class="label">SMS 수신</span>
                    <span class="badge optional">선택</span>
                  </div>
                  <span class="date">{{ customer.agree_sms_at ? formatDate(customer.agree_sms_at) : '-' }}</span>
                </div>

                <div class="agreement-view-item">
                  <div class="checkbox" :class="{ checked: customer.agree_email == 1 }">
                    <i class="ph-bold ph-check" v-if="customer.agree_email == 1"></i>
                  </div>
                  <div class="agreement-info">
                    <span class="label">이메일 수신</span>
                    <span class="badge optional">선택</span>
                  </div>
                  <span class="date">{{ customer.agree_email_at ? formatDate(customer.agree_email_at) : '-' }}</span>
                </div>
              </div>
            </div>

            <!-- <div class="detail-section">
              <h3>SNS 정보</h3>
              <div class="detail-grid">
                <div class="detail-row">
                  <span class="label">카카오톡</span>
                  <span class="value">{{ customer.sns_talk || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">아마존</span>
                  <span class="value">{{ customer.sns_ama || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">기타 SNS</span>
                  <span class="value">{{ customer.sns_etc || '-' }}</span>
                </div>
              </div>
            </div> -->

            <!-- <div class="detail-section" v-if="customer.notes">
              <h3>메모</h3>
              <div class="notes-area">
                <p>{{ customer.notes }}</p>
              </div>
            </div> -->
          </div>

          <!-- 직업정보 Section -->
          <div class="information" v-if="activeMenu === 'job'">
            <div class="info-header">
              <h2>💼 직업정보</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
            </div>

            <div class="detail-section">
              <h3>상세정보</h3>
              <div class="detail-grid">
                <div class="detail-row">
                  <span class="label">직업</span>
                  <span class="value">{{ customer.job || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">부서</span>
                  <span class="value">{{ customer.job_dept || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">직업 위험등급</span>
                  <span class="value">{{ customer.job_grade || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">직장명</span>
                  <span class="value">{{ customer.job_name || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">직장 전화</span>
                  <span class="value">{{ customer.job_phone || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">직장 주소</span>
                  <div class="address-wrapper">
                    <span class="value">{{ customer.job_adrs || '-' }}</span>
                    <button class="btn-map" v-if="customer.job_adrs">주변보기</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 가족정보 Section -->
          <div class="information" v-if="activeMenu === 'family'">
            <div class="info-header">
              <h2>👨‍👩‍👧‍👦 가족정보</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
            </div>

            <div class="detail-section" v-if="relation_info.length > 0">
              <h3>가족 구성원</h3>
              <div class="family-list">
                <div class="family-card" v-for="(member, index) in relation_info" :key="index">
                  <div class="family-header">
                    <span class="family-name">{{ member.linked_customer_name || '-' }}</span>
                    <h4>{{ member.relation_type || '' }}</h4>
                  </div>
                  <div class="family-details">
                    <div class="family-row">
                      <span class="label">생년월일:</span>
                      <span class="value">{{ member.linked_customer_rrn.split('-')[0] || '-' }}</span>
                    </div>
                    <div class="family-row">
                      <span class="label">성별:</span>
                      <span class="value">{{ genderChoser(member.linked_customer_rrn.split('-')[1].slice(0,1)) || '-' }}</span>
                    </div>
                    <div class="family-row" v-if="member.linked_customer_job">
                      <span class="label">직업:</span>
                      <span class="value">{{ member.linked_customer_job }}</span>
                    </div>
                    <div class="family-row" v-if="member.linked_customer_phone">
                      <span class="label">연락처:</span>
                      <span class="value">{{ member.linked_customer_phone }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="detail-section" v-else>
              <div class="empty-state">
                <p>등록된 가족 정보가 없습니다.</p>
              </div>
            </div>
          </div>

          <!-- 소개정보 Section -->
          <div class="information" v-if="activeMenu === 'sales'">
            <div class="info-header">
              <h2>👥 소개정보</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
            </div>

            <div class="detail-section" v-if="customer.extra_info">
              <h3>소개 관련 정보</h3>
              <div class="detail-grid">
                <div class="detail-row">
                  <span class="label">추가정보</span>
                  <span class="value">{{ JSON.stringify(customer.extra_info) }}</span>
                </div>
              </div>
            </div>

            <div class="detail-section" v-if="customer.notes">
              <h3>메모</h3>
              <div class="notes-area">
                <p>{{ customer.notes }}</p>
              </div>
            </div>

            <div class="detail-section" v-if="!customer.extra_info && !customer.notes">
              <div class="empty-state">
                <p>등록된 소개 정보가 없습니다.</p>
              </div>
            </div>
          </div>

          <!-- 보장 스캐치 Section -->
          <div class="information" v-if="activeMenu === 'insurance'">
            <div class="info-header">
              <h2>📊 보장 스캐치</h2>
            </div>
            <div class="solution-section">
              <div v-if="ca_info">
                <h3>보장 스캐치 목록</h3>
                <ul class="solution-list">
                  <li class="detail-row" v-for="ca in ca_info" :key="ca.idx" @click.stop="CA_openEdit(ca)">
                    <div>
                      <span>{{ ca.name }}</span>
                    </div>
                    <span class="value">
                      {{ ca.updated_at.split('T')[0].replace(/-/g, '.') }}
                    </span>
                    <span class="value">
                      {{ formatMoney(getSolutionPrice(ca)) }}원
                    </span>
                  </li>
                </ul>
              </div>
              <div class="empty-state" v-if="!ca_info || ca_info.length === 0">
                <p>이 고객과 연결된 보장 분석이 없습니다.</p>
              </div>
            </div>
          </div>

          <!-- 상품 가입정보 Section -->
          <div class="information" v-if="activeMenu === 'life'">
            <div class="info-header">
              <h2>📄 상품 가입정보</h2>
              <i class="ph ph-pencil"></i>
            </div>

            <div class="detail-section">
              <div class="empty-state">
                <p>가입된 상품 정보가 없습니다.</p>
              </div>
            </div>
          </div>

          <!-- 고지사항 Section -->
          <div class="information" v-if="activeMenu === 'employment'">
            <div class="info-header">
              <h2>🩺 고지사항 (병력사항)</h2>
              <i @click="editDialogSwitch(true)" class="ph ph-pencil"></i>
            </div>

            <div class="detail-section" v-if="!customer.med_history">
              <div class="empty-state">
                <p>등록된 고지사항이 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-else v-for="(med_his, i) in JSON.parse(customer.med_history)" :key="i">
              <div class="detail-row">
                <span class="label">{{med_his.when}}</span>
                <span class="value">
                  이유: {{ med_his.why }} <br>
                  장소: {{ med_his.where }} <br>
                </span>
                <span class="label">비고</span>
                <span class="value">{{ med_his.memo }}</span>
              </div>
            </div>
          </div>

          <!-- 청구이력 Section -->
          <div class="information" v-if="activeMenu === 'claims'">
            <div class="info-header">
              <h2>💰 청구이력</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
            </div>

            <div class="detail-section" v-if="claimsList.length === 0">
              <div class="empty-state">
                <p>청구 이력이 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-else>
              <h3>청구 목록</h3>
              <div class="claims-list">
                <div class="claim-card" v-for="(claim, i) in claimsList" :key="i">
                  <div class="claim-header">
                    <span class="company-name">{{ getCompanyName(claim.insu_company_idx) }}</span>
                    <span class="claim-status" :class="'status-' + claim.status">{{ claimStatusText(claim.status) }}</span>
                  </div>
                  <div class="claim-details">
                    <div class="claim-row">
                      <span class="label">청구일:</span>
                      <span class="value">{{ claim.request_date }}</span>
                    </div>
                    <div class="claim-row">
                      <span class="label">확정일:</span>
                      <span class="value">{{ claim.confirm_date || '-' }}</span>
                    </div>
                    <div class="claim-row">
                      <span class="label">금액:</span>
                      <span class="value amount">{{ formatMoney(claim.amount) }}원</span>
                    </div>
                    <div class="claim-row" v-if="claim.claim_content">
                      <span class="label">내용:</span>
                      <span class="value">{{ claim.claim_content }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 총 청구금액 요약 -->
            <div class="detail-section" v-if="claimsList.length > 0">
              <div class="claims-summary">
                <div class="summary-row">
                  <span class="label">총 청구건수:</span>
                  <span class="value">{{ claimsList.length }}건</span>
                </div>
                <div class="summary-row">
                  <span class="label">총 청구금액:</span>
                  <span class="value total">{{ formatMoney(totalClaimAmount) }}원</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 컨설이력 Section -->
          <div class="information" v-if="activeMenu === 'consultation'">
            <div class="info-header">
              <h2>📆 접촉이력</h2>
              <i @click="editDialogSwitch(true)" class="ph ph-pencil"></i>
            </div>

            <div class="detail-section">
              <h3>최근 접촉 일시</h3>
              <div class="detail-grid">
                <div class="detail-row">
                  <span class="label">마지막 접촉</span>
                  <span class="value">{{ customer.last_touch || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">등록일</span>
                  <span class="value">{{ customer.created_at || '-' }}</span>
                </div>
              </div>
            </div>

            <div class="detail-section" v-if="!customer_history">
              <div class="empty-state">
                <p>접촉 이력이 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-else v-for="(customer_history, i) in customer_history" :key="i">
              <div class="detail-row">
                <span class="label">{{ customer_history.created_at.split('T')[0].replace(/-/g, '.') }} ({{ getHistoryTypes(customer_history.type) }})</span>
                <span class="value">{{ customer_history.title }}</span>
                <span class="label">내용</span>
                <span class="value">[{{ customer_history.place }}]에서 {{ customer_history.content }}</span>
                <span class="label">상태와 다음행보</span>
                <span class="value">[{{ getStatusTypes(customer_history.status) }}] <br> {{ customer_history.next_action }}</span>
              </div>
            </div>
          </div>

          <!-- 기념일/이벤트 Section -->
          <div class="information" v-if="activeMenu === 'event'">
            <div class="info-header">
              <h2>🎂 기념일/이벤트</h2>
              <i @click="editDialogSwitch(true)" class="ph ph-pencil"></i>
            </div>

            <div class="detail-section" v-if="!myEvents">
              <div class="empty-state">
                <p>기념일/이벤트가 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-else>
              <div class="detail-row" v-for="(event, i) in myEvents" :key="i">
                <span class="label">{{ event.title }}</span>
                <span class="value">{{ event.event_datetime }}</span>
                <span class="label">설명</span>
                <span class="value">{{ event.text }}</span>
              </div>
            </div>
          </div>

          <!-- 자료보관 Section -->
          <div class="information" v-if="activeMenu === 'materials'">
            <div class="info-header">
              <h2>📁 자료보관</h2>
              <span @click="editDialogSwitch(true)"> <i class="ph ph-pencil"></i> </span>
            </div>

            <div class="detail-section" v-if="filesList.length === 0">
              <div class="empty-state">
                <p>등록된 자료가 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-else>
              <h3>자료 목록 ({{ filesList.length }}개)</h3>
              
              <!-- 이미지 그리드 -->
              <div class="image-grid" v-if="imageFiles.length > 0">
                <div 
                  class="image-thumb" 
                  v-for="(file, i) in imageFiles" 
                  :key="'img-' + i"
                  @click="openImagePreview(file)"
                >
                  <img :src="file.path" :alt="file.title" />
                  <div class="image-overlay">
                    <span class="image-name">{{ file.title }}</span>
                  </div>
                </div>
              </div>

              <!-- 문서 파일 리스트 -->
              <div class="files-list" v-if="docFiles.length > 0">
                <div class="file-card" v-for="(file, i) in docFiles" :key="'doc-' + i" @click="openFile(file)">
                  <div class="file-icon">
                    <i :class="getFileIcon(file.type)"></i>
                  </div>
                  <div class="file-info">
                    <span class="file-name">{{ file.title }}</span>
                    <span class="file-meta">{{ formatFileSize(file.size) }} · {{ formatDate(file.created_at) }}</span>
                  </div>
                  <button class="file-download" @click.stop="downloadFile(file)">
                    <i class="ph ph-download-simple"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 이미지 미리보기 모달 -->
          <div class="image-preview-modal" v-if="previewImage" @click="closeImagePreview">
            <div class="preview-container" @click.stop>
              <button class="preview-close" @click="closeImagePreview">
                <i class="ph ph-x"></i>
              </button>
              <img :src="previewImage.path" :alt="previewImage.title" />
              <div class="preview-info">
                <span class="preview-title">{{ previewImage.title }}</span>
                <span class="preview-meta">{{ formatFileSize(previewImage.size) }} · {{ formatDate(previewImage.created_at) }}</span>
              </div>
              <div class="preview-actions">
                <button @click="downloadFile(previewImage)">
                  <i class="ph ph-download-simple"></i> 다운로드
                </button>
                <button @click="openFile(previewImage)">
                  <i class="ph ph-arrow-square-out"></i> 새 탭에서 열기
                </button>
              </div>
            </div>
          </div>

          <!-- 메모 Section -->
          <div class="information" v-if="activeMenu === 'memo'">
            <div class="info-header">
              <h2>💬 메모</h2>
              <i @click="editDialogSwitch(true)" class="ph ph-pencil"></i>
            </div>

            <div class="detail-section">
              <h3>고객 메모</h3>
              <div class="notes-area">
                <p>{{ customer.notes || '작성된 메모가 없습니다.' }}</p>
              </div>
            </div>

          </div>

          <!-- 위치 및 주변고객 Section 부분만 수정 -->
          <div class="information" v-if="activeMenu === 'map'">
            <div class="info-header">
              <h2>📍 위치 및 주변고객</h2>
            </div>
            
            <div class="detail-section">
              <h3>고객 위치</h3>
              <div class="detail-grid" v-if="customer.location || customer.address">
                <div class="detail-row" v-if="customer.location">
                  <span class="label">지역</span>
                  <span class="value">{{ customer.location }}</span>
                </div>
                <div class="detail-row" v-if="customer.address">
                  <span class="label">주소</span>
                  <span class="value">{{ customer.address }}</span>
                </div>
              </div>
              <div class="empty-state" v-else>
                <p>등록된 위치 정보가 없습니다.</p>
              </div>
            </div>

            <div class="detail-section" v-if="customer.location || customer.address">
              <fuckingMap :customerId="customer.idx" :location="customer.address || customer.location" />
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject, computed } from "vue";

import dialog_CustomerEdit from '@/components/dialogs/customerEdit.vue';
import dialog_caEdit from '@/components/dialogs/caEdit.vue';
import fuckingMap from "@/components/kakaoSibalMap.vue";

import { useBackButton } from '@/utils/useBackBtn';

export default {
  components: {
    dialog_CustomerEdit,
    dialog_caEdit,
    fuckingMap
  },
  props: {
    customer: {
      type: Object,
      required: true
    },
    oth_viewCustomer: {
      type: Function,
      required: true
    },
    reloadForSync: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const calculateInsuAge = inject('calculateInsuAge');
    const formatKRPhone = inject('formatKRPhone');
    const activeMenu = ref('basic'); // Default to basic info
    const dialog_show = ref(false);
    const sql_query = inject('sql_query');
    const member_info = inject('member_info');
    const bookmarkChecked = ref(false);
    const useEditDialog = ref(false); // 추가
    const selectedSolution = ref(null);

    // 파일 관련
    // 이미지 미리보기 관련
    const previewImage = ref(null);

    // 이미지 파일 필터
    const imageFiles = computed(() => {
      return filesList.value.filter(file => isImageFile(file.type));
    });

    // 문서 파일 필터
    const docFiles = computed(() => {
      return filesList.value.filter(file => !isImageFile(file.type));
    });

    function isImageFile(type) {
      if (!type) return false;
      return type.startsWith('image/');
    }

    function openImagePreview(file) {
      previewImage.value = file;
      document.body.style.overflow = 'hidden'; // 스크롤 방지
    }

    function closeImagePreview() {
      previewImage.value = null;
      document.body.style.overflow = ''; // 스크롤 복원
    }

    const filesList = ref([]);

    async function fetchFiles() {
      let sql = `
        SELECT * FROM files 
        WHERE target_table = 'customers' 
        AND target_id = '${props.customer.idx}'
        AND status = 1
        ORDER BY created_at DESC
      `;
      let result = await sql_query(sql);
      filesList.value = result;
    }
    fetchFiles();

    function getFileIcon(type) {
      if (!type) return 'ph ph-file';
      if (type.includes('image')) return 'ph ph-image';
      if (type.includes('pdf')) return 'ph ph-file-pdf';
      if (type.includes('word') || type.includes('document')) return 'ph ph-file-doc';
      if (type.includes('excel') || type.includes('sheet')) return 'ph ph-file-xls';
      if (type.includes('text')) return 'ph ph-file-text';
      if (type.includes('video')) return 'ph ph-file-video';
      if (type.includes('audio')) return 'ph ph-file-audio';
      return 'ph ph-file';
    }

    function formatFileSize(bytes) {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    function formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
    }

    function openFile(file) {
      window.open(file.path, '_blank');
    }

    function downloadFile(file) {
      const link = document.createElement('a');
      link.href = file.path;
      link.download = file.title;
      link.click();
    }

    // 보험금 청구 관련
    const claimsList = ref([]);
    const companyList = ref([]);

    // 보험회사 목록 조회
    async function fetchCompanyList() {
      let sql = `SELECT idx, name FROM insu_company ORDER BY sort_no, name`;
      let result = await sql_query(sql);
      companyList.value = result;
    }
    fetchCompanyList();

    // 청구 목록 조회
    async function fetchClaims() {
      let sql = `SELECT * FROM insu_claims WHERE customer_idx = ${props.customer.idx} ORDER BY request_date ASC`;
      let result = await sql_query(sql);
      claimsList.value = result;
      calcTotalAmount();  // ← 이 한 줄 추가
    }
    fetchClaims();

    // 보험회사명 가져오기
    function getCompanyName(idx) {
      const company = companyList.value.find(c => c.idx === idx);
      return company ? company.name : '-';
    }

    // 청구 상태 텍스트
    function claimStatusText(status) {
      const statusMap = {
        0: '접수',
        1: '심사중',
        2: '승인',
        3: '지급완료',
        4: '반려'
      };
      return statusMap[status] || '-';
    }

    // 총 청구금액 계산 (computed 대신 일반 함수로)
    const totalClaimAmount = ref(0);
    function calcTotalAmount() {
      totalClaimAmount.value = claimsList.value.reduce((sum, claim) => sum + Number(claim.amount || 0), 0);
    }

    // EDIT 열기 (새로 추가)
    function CA_openEdit(solution) {
      selectedSolution.value = solution;
      editDialogOnOff(true);
    }

    // EDIT 다이얼로그 토글 (새로 추가)
    function editDialogOnOff(b) {
      useEditDialog.value = b;
    }

    useBackButton(() => {
      props.oth_viewCustomer(false);
    });

    const myEvents = ref([]);
    async function fetchEvents() {
      let sql = `select * from customer_events where customer_idx = ${props.customer.idx}`;
      let result = await sql_query(sql);
      myEvents.value = result;
    }
    fetchEvents();

    if (!props.customer.bookmark_idx || props.customer.bookmark_idx == 0 || props.customer.bookmark_idx == null || props.customer.bookmark_idx == undefined) {
      bookmarkChecked.value = false;
    } else {
      bookmarkChecked.value = true;
    }

    const relation_info = ref([]);
    const ca_info = ref([]);
    const customer_history = ref([]);

    function fetchCustomers() {
      console.log('ag');
    }

    async function fetchCustomerHistory() {
      let sql = `select * from customer_history where customer_idx = ${props.customer.idx}`;
      let result = await sql_query(sql);
      customer_history.value = result;
    }
    fetchCustomerHistory();

    let history_types = {'call':'전화', 'meet':'면담', 'consult':'상담', 'message':'메시지', 'service':'서비스', 'follow':'팔로우', 'other':'기타'};
    function getHistoryTypes(type) {
      return history_types[type];
    }

    let status_types = {'new':'신규', 'in_progress':'진행중', 'done':'완료', 'follow_up':'팔로업'};
    function getStatusTypes(type) {
      return status_types[type];
    }

    async function getRelations() {
      let sql = `
        SELECT 
          cr.*,
          c.idx as linked_customer_idx,
          c.name as linked_customer_name,
          c.nickname as linked_customer_nickname,
          c.phone as linked_customer_phone,
          c.rrn as linked_customer_rrn
        FROM customer_relations cr
        LEFT JOIN customers c ON cr.link_to = c.idx
        WHERE cr.customer_idx = ${props.customer.idx}
      `;
      let result = await sql_query(sql);
      relation_info.value = result;
    }
    getRelations();

    async function getCAInfo() {
      let sql = `select * from IS_solution where customer_idx = ${props.customer.idx}`;
      let result = await sql_query(sql);
      ca_info.value = result;
    }
    getCAInfo();
    
    function genderChoser(code) {
      if (!code || code == 0) {
        return '무성'
      }
      return code % 2 === 0 ? '여성' : '남성'
    }

    function editDialogSwitch(bool) {
      dialog_show.value = bool;
    }


    /** */

    const plans = ref([]);

    function formatMoney(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    async function fetchPlans() {
      const sql = `SELECT * FROM IS_plan WHERE mb_id = '${member_info.mb_id}' AND fav = '1' ORDER BY idx DESC LIMIT 0, 30`;
      const result = await sql_query(sql);
      
      plans.value = result.map(row => ({
        wr_id: row.idx,
        name: row.name,
        mb_id: row.mb_id,
        company: row.company,
        number: row.number,
        pay: row.pay,
        end: row.end,
        price: row.price,
        solution_id: row.solution_id,
        created_at: row.created_at,
        type: row.type,
        sub_type: row.sub_type,
      }));
    }
    fetchPlans();

    function getSolutionPrice(solution) {
      const relatedPlans = plans.value.filter(plan => plan.solution_id === solution.idx);
      if (relatedPlans.length === 0) return "0";
      
      const totalPrice = relatedPlans.reduce((sum, plan) => sum + parseFloat(plan.price || 0), 0);
      return totalPrice;
    }

    // setup 함수 내에서
    async function fetchCustomerInfo() {
      let sql = `SELECT 
        c.*,
        b.idx as bookmark_idx
      FROM customers c
      LEFT JOIN bookmark b ON b.target_idx = c.idx 
        AND b.target_table = 'customers' 
        AND b.mb_id = '${member_info.mb_id}'
      WHERE c.idx = ${props.customer.idx}`;

      let result = await sql_query(sql);

      if (result && result.length > 0) {
        const data = result[0];

        data.tags = JSON.parse(data.tags) || [],

        // props.customer 업데이트
        Object.assign(props.customer, data);

        // 북마크 상태
        bookmarkChecked.value = !!data.bookmark_idx;
      }
    }


    async function reloadAll() {
      await fetchCustomerInfo();
      props.reloadForSync();
      getRelations();
      getCAInfo();
      fetchCustomerHistory();
      fetchPlans();
      fetchEvents();
      fetchClaims();
      calcTotalAmount();
      fetchFiles();  // 추가
    }

    // 초기 로드
    fetchCustomerInfo();

    async function deleteCustomer() {
      let ask = confirm('고객을 삭제하시겠습니까?');
      if (ask) {
        let sql = `delete from customers where idx = ${props.customer.idx}`;
        let result = await sql_query(sql);
        if (result) {
          props.oth_viewCustomer(false)
          reloadAll();
        }
      } 
    }

    async function bookmarkToggle() {
      let sql = ``;
      console.log(bookmarkChecked.value);
      if(!bookmarkChecked.value) {
        bookmarkChecked.value = true;
        sql = `insert into bookmark set mb_id = '${member_info.mb_id}', target_idx = ${props.customer.idx}, target_table = 'customers'`;
      } else {
        bookmarkChecked.value = false;
        sql = `delete from bookmark where mb_id = '${member_info.mb_id}' and target_idx = ${props.customer.idx} and target_table = 'customers'`;
      }
      console.log(sql);
      let result = await sql_query(sql);
      if (result) {
        reloadAll();
      }
    }

    function goToUrl(url) {
      window.open(url);
    }

    const MANAGE_MAP = {
      1: 'PB (홍보)',
      2: 'PS (가망)',
      3: 'TA (연락)',
      4: 'AP (접근)',
      5: 'FF (설계)',
      6: 'PC (체결)',
      7: 'CS (관리)',
    };

    function manageText(value) {
      return MANAGE_MAP[value] || '';
    }

    function maskRRN(rrn) {
      if (!rrn) return '';

      // 060113-3406212 → 060113-3******
      if (/^\d{6}-\d{7}$/.test(rrn)) {
        return rrn.replace(/^(\d{6}-\d)(\d{6})$/, '$1******');
      }

      // 060113-3 → 060113-3******
      if (/^\d{6}-\d$/.test(rrn)) {
        return rrn + '******';
      }

      return rrn; // 그 외는 그대로
    }

    return {
      genderChoser,
      calculateInsuAge,
      formatKRPhone,
      activeMenu,
      dialog_show,
      editDialogSwitch,
      relation_info,
      ca_info,
      getSolutionPrice,
      formatMoney,
      customer_history,
      getHistoryTypes,
      status_types,
      getStatusTypes,
      fetchCustomers,
      reloadAll,
      deleteCustomer,
      bookmarkToggle,
      bookmarkChecked,
      myEvents,
      goToUrl,
      manageText,
      maskRRN,
      useEditDialog,
      selectedSolution,
      CA_openEdit, 
      editDialogOnOff,
      claimsList,
      companyList,
      getCompanyName,
      claimStatusText,
      totalClaimAmount,
      filesList,
      getFileIcon,
      formatFileSize,
      formatDate,
      openFile,
      downloadFile,
      previewImage,
      imageFiles,
      docFiles,
      openImagePreview,
      closeImagePreview,
    }
  }
}
</script>

<style scoped>
#dialog-customer-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  background: var(--color-surface);
  backdrop-filter: blur(var(--effect-blur));
}

.cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.paper {
  width: 100%;
  max-width: var(--break-point-tablet);
  height: 100%;
  max-height: 90%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-background-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 24px;
  box-sizing: border-box;
  background: var(--color-background);
  border-bottom: 1px solid var(--color-text-third);
}

.header > p {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  font-size: var(--font-size-md);
  cursor: pointer;
  margin: 0;
  padding: 0;
  font-weight: var(--font-weight-medium);
}

.header > p:last-child {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
  opacity: 0.6;
}

.content {
  display: flex;
  width: 100%;
  height: calc(100% - 60px);
  overflow: hidden;
}

/* Left Sidebar */
.left {
  width: 320px;
  background: var(--color-background);
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--color-text-third);
  overflow-y: auto;
}

.profile {
  position: relative;
  padding: 24px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  border-bottom: 1px solid var(--color-text-third);
}

.profile .bookmark {
  position: absolute;
  left: 20px;
  bottom: 20px;
  background:none;
  width:fit-content;
  border:none;
  cursor:pointer;
  padding:0;
  height:fit-content;
}

.profile .marked i {
  color: var(--color-brand) !important;
}

.profile .bookmark i {
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
}

.profile img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  background: var(--color-text-third);
}

.profile-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.name-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.name-badges h2 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-white);
}

.badge-coach {
  background: none;
}

.badge-mtype {
  background: #3155a8;
}

.badge-managerank {
  background: #7c4dff;
}

.badge-keyman {
  background: linear-gradient(45deg,rgba(17, 114, 189, 1) 0%, rgba(153, 35, 250, 1) 100%);
}

.badge-offical {
  background: linear-gradient(45deg,rgba(17, 114, 189, 1) 0%, rgba(35, 250, 207, 1) 100%);
}

.badge-vip {
  background: linear-gradient(45deg,rgba(189, 37, 17, 1) 0%, rgba(250, 182, 35, 1) 100%);
}

.nickname {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  opacity: 0.6;
}

.phone {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  font-weight: var(--font-weight-medium);
}

.menus {
  list-style: none;
  margin: 0;
  padding: 8px;
}

.menus li {
  padding: 14px 16px;
  cursor: pointer;
  border-radius: var(--radius-md);
  margin-bottom: 4px;
  transition: all 0.2s;
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  border: 2px solid transparent;
}

.menus li:hover {
  background: var(--color-background-light);
}

.menus li.active {
  font-size: var(--font-size-md);
  border: 2px solid var(--color-brand);
  font-weight: var(--font-weight-semibold);
  padding-left: 24px;
}

.menus li span {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Right Content */
.right {
  flex: 1;
  background: var(--color-background-light);
  overflow-y: auto;
  padding: 24px;
}

.information {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-header {
  background: var(--color-background);
  padding: 16px 20px;
  border-radius: var(--radius-lg);
  display:flex;
  justify-content: center;
  align-items: center;
  gap:16px;
}

.info-header h2 {
  flex:1;
  width:100%;
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-header span {
  cursor: pointer;
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
}

.info-summary {
  background: var(--color-background);
  padding: 20px;
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--font-size-base);
}

.summary-double {
  display: flex;
  align-items: center;
  gap: 16px;
}

.summary-double-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--font-size-base);
  padding:6px 12px;
  box-sizing:border-box;
  border-radius:12px;
  background:var(--color-background-light);
}

.summary-item .delete {
  cursor: pointer;
  padding:6px 12px;
  font-size:14px;
  color:#fff;
  background-color: var(--color-special-warning);
  border:none;
  border-radius: 12px;
}

.summary-item .label {
  color: var(--color-text-primary);
  font-weight: var(--font-weight-medium);
  min-width: 80px;
}

.summary-item .value {
  color: var(--color-text-primary);
}

.summary-item .value.safe {
  color: var(--color-special-point);
  font-weight: var(--font-weight-semibold);
}

.summary-item .tags {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 4px 12px;
  background: var(--color-background-light);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.btn-card {
  padding: 6px 14px;
  background: var(--color-special-point);
  color: var(--color-text-white);
  border: none;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  cursor: pointer;
  font-weight: var(--font-weight-medium);
  transition: all 0.2s;
}

.btn-card:hover {
  opacity: 0.8;
}

.detail-section {
  background: var(--color-background);
  border-radius: var(--radius-lg);
  padding: 20px;
}

.detail-section h3 {
  margin: 0 0 16px 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.solution-section {
  border-radius: var(--radius-lg);
}

.solution-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding:0;
  margin:0;
  list-style-type: none;
}

.solution-list li {
  display: flex;
  align-items: center;
  height:48px;
  gap: 16px;
  padding:6px 12px;
  background:var(--color-surface);
  border-radius: var(--radius-lg);
  cursor:pointer;
}

.solution-list li div {
  display:flex;
  width:100%;
  flex:2;
}

.solution-list li div {
  flex:2;
}

.solution-list li div > span {
  width:fit-content;
  height:fit-content;
  background-color: var(--color-brand);
  font-size:var(--font-size-md);
  color:var(--color-text-black);
  padding:6px 12px;
  border-radius: 12px;
  font-weight: 600;
}

.solution-list li > span {
  flex:1;
  display:flex;
  align-items: center;
  justify-content: center;
}

.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 16px;
  align-items: start;
  padding: 14px 0;
  border-bottom: 1px solid var(--color-text-third);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-row .label {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  opacity: 0.6;
  font-weight: var(--font-weight-medium);
}

.detail-row .value {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  line-height: 1.6;
}

.address-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.address-wrapper .value {
  flex: 1;
}

.btn-map {
  padding: 6px 14px;
  background: var(--color-special-point);
  color: var(--color-text-white);
  border: none;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  cursor: pointer;
  font-weight: var(--font-weight-medium);
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-map:hover {
  opacity: 0.8;
}

/* Notes Area */
.notes-area {
  padding: 16px;
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  min-height: 100px;
}

.notes-area p {
  margin: 0;
  color: var(--color-text-primary);
  line-height: 1.6;
  font-size: var(--font-size-base);
  white-space: pre-wrap;
}

/* Empty State */
.empty-state {
  padding: 40px 20px;
  text-align: center;
}

.empty-state p {
  margin: 0;
  color: var(--color-text-primary);
  opacity: 0.5;
  font-size: var(--font-size-base);
}

/* Family List */
.family-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.family-card {
  padding: 16px;
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-text-third);
}

.family-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-text-third);
}

.family-header h4 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.family-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.family-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.family-row {
  display: flex;
  gap: 12px;
  font-size: var(--font-size-sm);
}

.family-row .label {
  color: var(--color-text-primary);
  opacity: 0.6;
  min-width: 80px;
}

.family-row .value {
  color: var(--color-text-primary);
}

/* Scrollbar Styling */
.left::-webkit-scrollbar,
.right::-webkit-scrollbar {
  width: 8px;
}

.left::-webkit-scrollbar-track,
.right::-webkit-scrollbar-track {
  background: var(--color-background-light);
}

.left::-webkit-scrollbar-thumb,
.right::-webkit-scrollbar-thumb {
  background: var(--color-text-secondary);
  border-radius: var(--radius-sm);
}

.left::-webkit-scrollbar-thumb:hover,
.right::-webkit-scrollbar-thumb:hover {
  opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }
  
  .left {
    width: 100%;
    max-height: 40%;
    border-right: none;
    border-bottom: 1px solid var(--color-text-third);
  }
  
  .detail-row {
    grid-template-columns: 100px 1fr;
  }
}

/* Claims List */
.claims-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.claim-card {
  padding: 16px;
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-text-third);
}

.claim-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-text-third);
}

.claim-header .company-name {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.claim-status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-white);
}

.claim-status.status-0 { background: #9e9e9e; }
.claim-status.status-1 { background: #ff9800; }
.claim-status.status-2 { background: #2196f3; }
.claim-status.status-3 { background: #4caf50; }
.claim-status.status-4 { background: #f44336; }

.claim-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.claim-row {
  display: flex;
  gap: 12px;
  font-size: var(--font-size-sm);
}

.claim-row .label {
  color: var(--color-text-primary);
  opacity: 0.6;
  min-width: 60px;
}

.claim-row .value {
  color: var(--color-text-primary);
}

.claim-row .value.amount {
  font-weight: var(--font-weight-semibold);
  color: var(--color-brand);
}

.claims-summary {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
}

.claims-summary .summary-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.claims-summary .label {
  color: var(--color-text-primary);
  opacity: 0.6;
}

.claims-summary .value {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.claims-summary .value.total {
  font-size: var(--font-size-lg);
  color: var(--color-brand);
}
/* Files List */
.files-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.file-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-text-third);
  cursor: pointer;
  transition: all 0.2s;
}

.file-card:hover {
  border-color: var(--color-brand);
}

.file-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  border-radius: var(--radius-md);
  font-size: 24px;
  color: var(--color-brand);
}

.file-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.file-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.file-download {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  border: none;
  border-radius: var(--radius-md);
  font-size: 20px;
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.file-download:hover {
  background: var(--color-brand);
  color: var(--color-text-black);
}

/* Image Grid */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.image-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.image-thumb:hover {
  border-color: var(--color-brand);
  transform: scale(1.02);
}

.image-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  opacity: 0;
  transition: opacity 0.2s;
}

.image-thumb:hover .image-overlay {
  opacity: 1;
}

.image-name {
  font-size: var(--font-size-xs);
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Image Preview Modal */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  padding: 20px;
  box-sizing: border-box;
}

.preview-container {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.preview-container img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: var(--radius-md);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.preview-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.preview-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.preview-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: #fff;
}

.preview-meta {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.6);
}

.preview-actions {
  display: flex;
  gap: 12px;
}

.preview-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--radius-md);
  color: #fff;
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all 0.2s;
}

.preview-actions button:hover {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-text-black);
}

/* 수신동의 보기 스타일 */
.agreement-view-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.agreement-view-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--color-text-third);
}

.agreement-view-item:last-child {
  border-bottom: none;
}

.agreement-view-item .checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid var(--color-text-secondary);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  opacity: 0.4;
}

.agreement-view-item .checkbox.checked {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-text-black);
  opacity: 1;
}

.agreement-view-item .agreement-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.agreement-view-item .agreement-info .label {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}

.agreement-view-item .badge {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: var(--font-weight-bold);
}

.agreement-view-item .badge.required {
  background: var(--color-special-point);
  color: var(--color-text-white);
}

.agreement-view-item .badge.optional {
  background: var(--color-background-light);
  color: var(--color-text-secondary);
}

.agreement-view-item .date {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  white-space: nowrap;
}

@media (max-width: 1024px), (max-height: 768px) {
  #dialog-customer-view {
    padding:0 !important;
  }
  .paper {
    width: 100%;
    max-width: 100% !important;
    height: 100%;
    max-height: 100% !important;
    background-color: var(--color-background-light);
    border-radius: 0px !important;
  }
  
  .image-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .preview-container img {
    max-height: 50vh;
  }
  
  .preview-actions {
    flex-direction: column;
    width: 100%;
  }
  
  .preview-actions button {
    justify-content: center;
  }
}
</style>